// extracted by mini-css-extract-plugin
export default {"root":"BaseFareName-module__root___uJlng"};